import React from 'react';
import {
    MOTIVOS_EXPRES,
    MOTIVO_EXPRES_OTRO,
    MAX_DOCUMENTACION_EXPRES,
    MAX_MOTIVO_DETALLE_EXPRES,
    MAX_OBSERVACION_EXPRES,
} from '../../constants/tramiteExpres';

/**
 * Campos del trámite exprés: qué entregó o retiró, por qué fue exprés y observaciones. Controlado:
 * el padre guarda `valor` ({ documentacion, motivo, motivoDetalle, observaciones }) y valida con
 * datosExpresValidos. Lo usan ModalReingresoCliente (exprés de un atendido de hoy) y
 * ModalTramiteExpres (sin turno previo).
 */
function CamposTramiteExpres({ valor, onChange, disabled = false, idPrefijo = 'expres' }) {
    const cambiar = (campo) => (e) => onChange({ ...valor, [campo]: e.target.value });

    const elegirMotivo = (motivo) => onChange({
        ...valor,
        motivo,
        // El detalle solo vale para "Otro": no se manda un texto viejo con otro motivo.
        motivoDetalle: motivo === MOTIVO_EXPRES_OTRO ? valor.motivoDetalle : '',
    });

    return (
        <>
            <label className="form-label fw-semibold mt-3 mb-2" htmlFor={`${idPrefijo}-documentacion`}>
                ¿Qué entregó o retiró? *
            </label>
            <textarea
                id={`${idPrefijo}-documentacion`}
                className="form-control rounded-4"
                rows={3}
                maxLength={MAX_DOCUMENTACION_EXPRES}
                placeholder="Ej.: trajo el recibo de sueldo y la copia del DNI"
                value={valor.documentacion}
                onChange={cambiar('documentacion')}
                disabled={disabled}
            />
            <div className="form-text text-end">{valor.documentacion.length}/{MAX_DOCUMENTACION_EXPRES}</div>

            <label className="form-label fw-semibold mt-2 mb-2">¿Por qué fue un trámite exprés? *</label>
            <div className="rec-expres-motivos" role="radiogroup">
                {MOTIVOS_EXPRES.map((m) => {
                    const activo = valor.motivo === m.valor;
                    return (
                        <button
                            key={m.valor}
                            type="button"
                            role="radio"
                            aria-checked={activo}
                            className={`rec-expres-motivo ${activo ? 'rec-expres-motivo--activo' : ''}`}
                            onClick={() => elegirMotivo(m.valor)}
                            disabled={disabled}
                        >
                            <i className={`bi ${m.icono} me-2`}></i>
                            {m.etiqueta}
                        </button>
                    );
                })}
            </div>
            {valor.motivo === MOTIVO_EXPRES_OTRO && (
                <input
                    type="text"
                    className="form-control rounded-4 mt-2"
                    maxLength={MAX_MOTIVO_DETALLE_EXPRES}
                    placeholder="Contá brevemente por qué *"
                    value={valor.motivoDetalle}
                    onChange={cambiar('motivoDetalle')}
                    disabled={disabled}
                    autoFocus
                />
            )}

            <label className="form-label fw-semibold mt-3 mb-2" htmlFor={`${idPrefijo}-observaciones`}>
                Observaciones (opcional)
            </label>
            <textarea
                id={`${idPrefijo}-observaciones`}
                className="form-control rounded-4"
                rows={2}
                maxLength={MAX_OBSERVACION_EXPRES}
                placeholder="Ej.: falta la constancia de CUIL, la trae la semana que viene"
                value={valor.observaciones}
                onChange={cambiar('observaciones')}
                disabled={disabled}
            />
        </>
    );
}

export default CamposTramiteExpres;
